export const detailedSearchState = state => ( { pageResult: state.pageResult } );